import React, { Component } from 'react';
import Select from 'react-select';
import './TableMenus.css';
import './DropdownSearch.css';

const colsList = [];
colsList.push({ value: `Default`, label: `Default`});
for (var j = 1; j < 17; j++) {
    colsList.push({ value: `${j}`, label: `Columns: ${j}`});
}

class TableMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: "Default",
            cols: "Default",
        };

        this.onTableColChange = this.onTableColChange.bind(this);
    }

    onTableColChange(e) {
        this.setState({ cols: e.value });

        var newTable = this.props.displayTable;
        newTable.cols = e.value;
        this.props.onTableListChange(newTable);
    }

    render() {

        return (
            <div className="box">
                <div className="col">
                    <p>Table View</p>
                </div>

                    <Select
                        options={colsList}
                        onChange={this.onTableColChange}
                        placeholder="Columns"
                        defaultValue = {{ label: `Columns: ${this.props.displayTable.cols}`, value: this.props.displayTable.cols }} />

            </div>
        )
    }
}

export default TableMenu;